import axios from 'axios'
import Wix from 'Wix'

Wix.Utils.getInstance = function() {
    var url = window.location;
    var instanceRegexp = /.*instance=([\[\]a-zA-Z0-9\.\-_]*?)(&|$|#).*/g;
    var instance = instanceRegexp.exec(url);
    if (instance && instance[1]) {
        return instance[1];
    } else {
        return undefined;
    }
};

const URL = `api/settings?compId=${Wix.Utils.getOrigCompId()}&instance=${Wix.Utils.getInstance()}`
const lastDateUpdateURL = `api/lastDateUpdate?compId=${Wix.Utils.getOrigCompId()}&instance=${Wix.Utils.getInstance()}`
const URLSaleInfo = `https://templates.light-tech.online/getInfoForUser?instance=${Wix.Utils.getInstance()}&app=textSlider`
const URLSaleUse = `/sale/premToTemplates?instance=${Wix.Utils.getInstance()}`

const server = {
    async getSettings() {
        // console.log('async getSettings()');
        const { data } = await axios.get(URL)
        return data
    },
    async createSettings(send) {
        const { data } = await axios.post(URL, {settings: send})
        return data.settings
    },
    async editSettings(send) {
        // console.log('async editSettings(send)');
        const { data } = await axios.put(URL, {settings: send})
        return data
    },
    async deleteSettings() {

    },
    async getTemplates() {
        const { data } = await axios.get(`/getTemplates`)
        // console.log('response data',data);
        return data.templates
    },
    async getLastDateUpdate() {
        const { data } = await axios.get(lastDateUpdateURL)
        return data
    },
    async setTrialReminderOverWatched() {
        const reqBody = {
            siteOwnerId: Wix.Utils.getSiteOwnerId(),
            instanceId: Wix.Utils.getInstanceId()
        }
        const request = await axios.post('/setTrialReminderOverWatched', reqBody)
        return request
    },
    async setTrialReminderTwoDaysWatched() {
        const reqBody = {
            siteOwnerId: Wix.Utils.getSiteOwnerId(),
            instanceId: Wix.Utils.getInstanceId()
        }
        const request = await axios.post('/setTrialReminderTwoDaysWatched', reqBody)
        return request
    },
    async setCoundownNotificationWatched() {
        const reqBody = {
            siteOwnerId: Wix.Utils.getSiteOwnerId(),
            instanceId: Wix.Utils.getInstanceId()
        }
        const request = await axios.post('/setCoundownNotificationWatched', reqBody)
        return request
    },
    async getSaleInfo() {
        const request = await axios.get(URLSaleInfo)
        return request
    },
    async useSaleAsPremium() {
        const request = await axios.post(URLSaleUse)
        return request
    }

}

export default server;